import { render, staticRenderFns } from "./CuttingModul.vue?vue&type=template&id=4e704c86"
import script from "./CuttingModul.vue?vue&type=script&lang=js"
export * from "./CuttingModul.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports